import type { ActionContext } from 'vuex'

import type { ActionClass, AnalyticsState } from '../../../models'

import { ANALYTICS_CONSTS } from '../analytics.consts'

export class SetSelectedIdAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<AnalyticsState, any>,
    selectedId: string,
  ): void {
    commit(ANALYTICS_CONSTS.mutations.setSelectedId, selectedId)
  }
}
